$(function() {

	/*
	 * Taurus Website scripts.
	 */

	/*------------------------------------*\
	    ACTIVE NAVIGATION STATE
	\*------------------------------------*/

	function setActiveNavigation() {
		var currentPath = window.location.pathname;

		// Normalize: remove trailing slash (except for root)
		if (currentPath !== '/' && currentPath.endsWith('/')) {
			currentPath = currentPath.slice(0, -1);
		}
		// Handle /index.html as root
		if (currentPath === '/index.html') {
			currentPath = '/';
		}

		// Select all nav links (desktop and mobile)
		var navLinks = document.querySelectorAll('.main-navigation a, .responsive-menu-overlay a');

		navLinks.forEach(function(link) {
			var linkPath = link.getAttribute('href');
			if (linkPath === '#') return; // Skip dropdown parents

			// Normalize link path
			if (linkPath !== '/' && linkPath.endsWith('/')) {
				linkPath = linkPath.slice(0, -1);
			}
			if (linkPath === '/index.html') {
				linkPath = '/';
			}

			// Exact match or subpage match
			if (currentPath === linkPath ||
				(linkPath !== '/' && currentPath.startsWith(linkPath + '/'))) {
				link.classList.add('active');
			}
		});
	}

	// Page load
	setActiveNavigation();

	/*------------------------------------*\
	    OMIT CURRENT PAGE SERVICE > SINGLE SERVICE PAGE
	\*------------------------------------*/

	function omitCurrentServiceFromList() {
		// Only fire when its a single service page
		if (window.location.href.indexOf("our-services/") > -1) {
			// Get page title
			var pageTitle = $('.our-services-intro-wrapper').find('h1').text();
			// Get loop selector
			var otherServiceListItem = $('.card-service-type-our-services');
			// Loop over each service item
			$(otherServiceListItem).each(function() {
				var title = $(this).find('h3').text();

				if (title == pageTitle) {
					$(this).parent().remove();
				}
			});
		}
	}

	// Page load
	omitCurrentServiceFromList();

	/*------------------------------------*\
	    CLOSE MOBILE DID YOU KNOW BANNER
	\*------------------------------------*/

	$(document).on('click', function (e) {
	    if ($(e.target).closest('.banner-did-you-know-mobile').length === 0) {
	        $('.mobile-toggle').removeClass('expanded');
	        $('.banner-did-you-know-mobile').find('.hidden').slideUp();
	    }
	});

	/*------------------------------------*\
	    DENY BLANK SEARCH OF NEWS ARTICLES
	\*------------------------------------*/

	var searchForm = $('.search');
	var searchInput = $('#search-box');
	var searchButton = $('.search-button');

	function preventBlankSearch() {
		if ($(searchInput).val().length <= 2) {

		    $(searchForm).submit(function(e){
		        e.preventDefault();
		    });

	        $.magnificPopup.open({
	          items: {
	            src: '#dialog-empty-search'
	          },
	          type: 'inline',
	          mainClass: 'my-mfp-slide-bottom',
	          closeMarkup: '<button title="%title%" class="mfp-close"><img src="/taurus-website/assets/svg/icon-plus.svg" width="19" height="18"/></button>',
	        });
		}
		else {
		    $(searchForm).unbind('submit').submit();
		}
	}

	$(searchButton).on('click', function() {
		preventBlankSearch();
	});


	$(searchInput).keypress(function(event){
	    var keycode = (event.keyCode ? event.keyCode : event.which);
	    if(keycode == '13'){
	    	preventBlankSearch();
	    }
	});

	/*------------------------------------*\
	    VALIDATE ARRANGE A CALL FORM
	\*------------------------------------*/

	var arrangeCallForm = $('.arrange-a-call');
	var validateButton = $('.validate-form');
	var firstName = $('#fname');
	var lastName = $('#lname');
	var mobile = $('#mobile');
	var email = $('#email');
	var callTime = $('#call-time');

	function validateArrangeCallForm() {

		var firstNameFailed = $(firstName).val().length <= 2;
		var lastNameFailed = $(lastName).val().length <= 2;
		var mobileFailed = $(mobile).val().length != 11;
		var emailFailed = $(email).val().length >= 3 == false || $(email).val().indexOf("@") > -1 == false;
		var callTimeFailed = $(callTime).val().length != 16;

		if (firstNameFailed || lastNameFailed || mobileFailed || emailFailed || callTimeFailed) {
			// Prevent form being submitted - intercept
		    $(arrangeCallForm).submit(function(e){
		        e.preventDefault();
		    });
		}
		else {
		    $(arrangeCallForm).unbind('submit').submit();
		}

		if (firstNameFailed) {
		    $(firstName).addClass('error');
		    $( "<div class='error-message'>Complete the field above.</div>" ).insertAfter(firstName);
		    $('.error').first().get(0).focus();
		}

		if (lastNameFailed) {
		    $(lastName).addClass('error');
		    $( "<div class='error-message'>Complete the field above.</div>" ).insertAfter(lastName);
		    $('.error').first().get(0).focus();
		}

		if (mobileFailed) {
		    $(mobile).addClass('error');
		    $( "<div class='error-message'>Complete the field above.</div>" ).insertAfter(mobile);
		    $('.error').first().get(0).focus();
		}

		if (emailFailed) {
		    $(email).addClass('error');
		    $( "<div class='error-message'>Complete the field above.</div>" ).insertAfter(email);
		    $('.error').first().get(0).focus();
		}

		if (callTimeFailed) {
		    $(callTime).addClass('error');
		    $( "<div class='error-message'>Complete the field above.</div>" ).insertAfter(callTime);
		    $('.error').first().get(0).focus();
		}
	}

	// Click event
	$(validateButton).on('click', function () {
		$('input').removeClass('error');
		$('.error-message').remove();

		setTimeout(function(){
			validateArrangeCallForm();
		}, 50);
	});


	/*------------------------------------*\
	    AS SEEN ON LOGO CAROUSEL
	\*------------------------------------*/

	$('.logo-carousel').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 4000,
		pauseOnHover: false,
		accessibility: false,
		prevArrow: false,
    	nextArrow: false,
		  responsive: [
		    {
		      breakpoint: 1200,
		      settings: {
		        slidesToShow: 3,
		        slidesToScroll: 3
		      }
		    },
		    {
		      breakpoint: 769,
		      settings: {
		        slidesToShow: 2,
		        slidesToScroll: 2
		      }
		    },
		    {
		      breakpoint: 480,
		      settings: {
		        slidesToShow: 1,
		        slidesToScroll: 1
		      }
		    }
		    // You can unslick at a given breakpoint now by adding:
		    // settings: "unslick"
		    // instead of a settings object
		  ]
	});

	/*------------------------------------*\
	    NEWS CATEGORY REDIRECT
	\*------------------------------------*/

	$('#filter-category').on('change', function () {
		var url = $(this).val();
		if (url) {
			window.location = url;
		}
		return false;
	});

	/*------------------------------------*\
	    PREVIOUS PAGE BUTTON
	\*------------------------------------*/

	$('.previous-page').on('click', function() {
		window.history.back();
	});

	/*------------------------------------*\
	    ARRANGE A CALL DIALOG
	\*------------------------------------*/

	$('.trigger-dialog-arrange-call').on('click', function(e) {
		e.preventDefault();

        $.magnificPopup.open({
          items: {
            src: '#dialog-arrange-call'
          },
          type: 'inline',
          mainClass: 'my-mfp-slide-bottom',
          closeMarkup: '<button title="%title%" class="mfp-close"><img src="/assets/svg/icon-plus.svg" width="19" height="18"/></button>',
			callbacks: {
			    beforeOpen: function() {  this.wrap.removeAttr('tabindex') }
			}
        });
	});

	// Common close button
    $('.close-copied').on( 'click', function(e) {
    	e.preventDefault();
        $.magnificPopup.close();
        $('.mfp-close').trigger('click');
    });

    // Form Datepicker
    $('#call-time').flatpickr({
		enableTime: true,
    	dateFormat: "d-m-Y H:i",
		minDate: "today",
		minTime: "09:00",
		maxTime: "17:00",
		time_24hr: true
    });

	/*------------------------------------*\
	    COPY ARTICLE SHARE LINK
	\*------------------------------------*/

    var clipboard = new ClipboardJS('.copy-link');

    clipboard.on('success', function(e) {

        $.magnificPopup.open({
          items: {
            src: '#dialog-link-copied'
          },
          type: 'inline',
          modal: true,
          mainClass: 'my-mfp-slide-bottom',
          fixedContentPos: true
        });

        e.clearSelection();
    });

	/*------------------------------------*\
	    SOCIAL SHARING NEWS ARTICLES
	\*------------------------------------*/

    // Common
    var pageURL = window.location.href;
    // console.log('pageurl is ' + pageURL);
    var documentTitle = document.title;

    // Twitter (Working)
    var twitterURL = 'https://twitter.com/share?text='+ documentTitle +'&amp;url='+(pageURL);
    // console.log('twitterURL is ' + twitterURL);

    $('.twitter').on('click', function() {
        window.open('https://twitter.com/share?text='+ documentTitle +'&amp;url='+(pageURL),'Twitter-dialog','width=626,height=436');
        return false;
    });

	/*------------------------------------*\
	    READING TIME
	\*------------------------------------*/

    var copy = $(".article-body").text();
    
    wordCount = copy.replace( /[^\w ]/g, "" ).split( /\s+/ ).length;

    var readingTimeInMinutes = Math.floor(wordCount / 200) + 1;

    if (readingTimeInMinutes == 1) {
        var readingTimeAsString = readingTimeInMinutes + " minute";
    }
    else {
        var readingTimeAsString = readingTimeInMinutes + " minutes";
    }
    
    $('#reading-time').html(readingTimeAsString);
    

	/*------------------------------------*\
	    MAIN NAV DROPDOWN
	\*------------------------------------*/

	$('.nav-dropdown').hide();

	// Desktop
	$('.parent').on('click', function(e) {
		e.preventDefault();

		// Check if this dropdown is currently open
		var isOpen = $(this).hasClass('parent-open');

		// Close all other dropdowns
		$('.parent').not(this).removeClass('parent-open');
		$('.nav-dropdown').not($(this).next('.nav-dropdown')).fadeOut(400);

		// Toggle this dropdown
		$(this).toggleClass('parent-open');
		$(this).next('.nav-dropdown').fadeToggle(400);
		$(this).next('a').toggleClass('expanded');
	});

	if ($(window).width() > 768) {
		$(document).click(function(e) {
			if (!$(e.target).closest('li').find('.nav-dropdown').length) {
				$('.nav-dropdown').fadeOut(400);
				$('.parent').removeClass('parent-open');
			}
		});

		$('.parent').click(function(e) {
		    e.stopPropagation(); // This is the preferred method.
		    return false;        // This should not be used unless you do not want
		                         // any click events registering inside the div
		});
	}
	
	/*------------------------------------*\
	    DID YOU KNOW BANNER MOBILE
	\*------------------------------------*/

	$('.banner-did-you-know-mobile').find('.hidden').hide();

	$('.mobile-toggle').on('click', function() {
		$(this).toggleClass('expanded');
		$(this).parent().parent().next('.hidden').slideToggle(400);
		return false;
	});

	/*------------------------------------*\
	    Bootstrap +/- accordion
	\*------------------------------------*/

    $(".collapse").on('show.bs.collapse', function(){
    	$(this).prev(".card-header").find(".plus-minus").html('-');
    }).on('hide.bs.collapse', function(){
    	$(this).prev(".card-header").find(".plus-minus").html('+');
    });

	/*------------------------------------*\
	    Toggle responsive menu.
	\*------------------------------------*/

	$('.hamburger').on('click', function(e) {
		e.preventDefault();
		$(this).toggleClass('is-active');
		$('.responsive-menu-contents').fadeToggle();
		$('.responsive-menu-overlay').fadeToggle();
		$('html').toggleClass('prevent-scroll');

		var childIsActive = $('.nav-dropdown').find('li a').hasClass('active');

		if (childIsActive == true) {
			
			$('.parent').addClass('parent-open');
			$('.parent-mob').addClass('expanded');
			$('.nav-dropdown').show();
		
			var $container = $('.responsive-menu-overlay');
			var $scrollTo = $('.active');
			$container.animate({scrollTop: $scrollTo.offset().top - $container.offset().top + $container.scrollTop(), scrollLeft: 0},0);
		}
	});

	// Shared toggle for mobile menu dropdowns.
	// Both .mob-inline (text) and .parent-mob (icon) use .dropdown-open on the <li> as the single source of truth.
	function toggleMobileDropdown($li) {
		var $dropdown = $li.find('> .nav-dropdown');
		var $icon = $li.find('> .parent-mob');
		var isOpen = $li.hasClass('dropdown-open');

		// Close all other dropdowns
		$li.siblings().removeClass('dropdown-open')
			.find('> .parent-mob').removeClass('expanded');
		$li.siblings().find('> .nav-dropdown').slideUp();

		// Toggle this one
		if (isOpen) {
			$li.removeClass('dropdown-open');
			$icon.removeClass('expanded');
			$dropdown.slideUp();
		} else {
			$li.addClass('dropdown-open');
			$icon.addClass('expanded');
			$dropdown.slideDown();
		}
	}

	$('.parent-mob').on('click', function(e) {
		e.preventDefault();
		toggleMobileDropdown($(this).closest('li'));
	});

	$('.responsive-menu-overlay .mob-inline').on('click', function(e) {
		e.preventDefault();
		e.stopImmediatePropagation();
		toggleMobileDropdown($(this).closest('li'));
	});

	/*------------------------------------*\
	    Smooth scroll anchor links.
	\*------------------------------------*/
	
	$('a[href*="#"]')
	  // Remove links that don't actually link to anything
	  .not('[href="#"]')
	  .not('[href="#0"]')
	  .click(function(event) {
	    // On-page links
	    if (
	      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
	      && 
	      location.hostname == this.hostname
	    ) {
	      // Figure out element to scroll to
	      var target = $(this.hash);
	      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
	      // Does a scroll target exist?
	      if (target.length) {
	        // Only prevent default if animation is actually gonna happen
	        event.preventDefault();
	        $('html, body').animate({
	          scrollTop: target.offset().top
	        }, 1000, function() {
	          // Callback after animation
	          // Must change focus!
	          var $target = $(target);
	          $target.focus();
	          if ($target.is(":focus")) { // Checking if the target was focused
	            return false;
	          } else {
	            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
	            $target.focus(); // Set focus again
	          };
	        });
	      }
	    }
	  });

	  // Smooth scroll anchors for sticky navbar ONLY
		$('.banner-navbar-menu').on('click', 'a[href^="#"]', function (event) {
		    event.preventDefault();

		    $('html, body').animate({
		        scrollTop: $($.attr(this, 'href')).offset().top-100
		    }, 1000);
		});

	/*------------------------------------*\
	    NEWS > LATEST NEWS
	\*------------------------------------*/

	function swiperNewsLatestNews() {
	    var swiper = new Swiper('.news-latest-news-mobile', {
	      slidesPerView: 1,
	      spaceBetween: 30,

			hashNavigation: {
				watchState: true,
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'fraction',
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
	    });
	}

	// Page load
	swiperNewsLatestNews();

	/*------------------------------------*\
	    HOME PAGE > OUR SERVICES
	\*------------------------------------*/

	function swiperHomeOurServices() {
	     var swiper = new Swiper('.swiper-container-home-our-services', {
	     spaceBetween: 30,
	      scrollbar: {
	        el: '.swiper-scrollbar-home-our-services',
	        hide: false,
	      },
	        snapOnRelease: true,
	        slidesPerView: 'auto',
	    });
	}

	// Page load
	swiperHomeOurServices();

	/*------------------------------------*\
	    HOME PAGES > OUR BRANDS
	\*------------------------------------*/

	function swiperHomeOurBrands() {
	    var swiperHomeOurBrands = new Swiper('.swiper-container-home-our-brands-mobile', {
			hashNavigation: {
				watchState: true,
			},
			pagination: {
				el: '.swiper-pagination-home-our-brands-mobile',
				clickable: true,
			},
	    });
	}

	// Page load
	swiperHomeOurBrands();

	/*------------------------------------*\
	    HOME PAGES > LATEST NEWS
	\*------------------------------------*/

	function swiperHomeLatestNews() {
	    var swiperHomeLatestNews = new Swiper('.swiper-container-home-latest-news-mobile', {
			hashNavigation: {
				watchState: true,
			},
			pagination: {
				el: '.swiper-pagination-home-latest-news-mobile',
				clickable: true,
			},
	    });
	}

	// Page load
	swiperHomeLatestNews();

	/*------------------------------------*\
	    ABOUT US > OUR TEAM MOBILE
	\*------------------------------------*/

	function swiperAboutUsOurTeam() {
	    var swiper = new Swiper('.about-us-our-team-mobile', {
			hashNavigation: {
				watchState: true,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
	    });
	}

	// Page load
	swiperAboutUsOurTeam();

	/*------------------------------------*\
	    ABOUT US > DID YOU KNOW?
	\*------------------------------------*/

	function swiperAboutUsDidYouKnow() {
	     var swiper = new Swiper('.about-us-did-you-know', {
	     spaceBetween: 30,
	      scrollbar: {
	        el: '.swiper-scrollbar',
	        hide: false,
	      },
	        snapOnRelease: true,
	        slidesPerView: 'auto',
	    });
	}

	// Page load
	swiperAboutUsDidYouKnow();

	/*------------------------------------*\
	    ABOUT US > TIMELINE
	\*------------------------------------*/

	function swiperAboutUsTimeline() {
		var swiper = new Swiper('.timeline-swiper', {
			direction: 'vertical',
			slidesPerView: 'auto',
			spaceBetween: 0,
			freeMode: false,
			slidesPerGroup: 4,
			initialSlide: 0,
			navigation: {
				nextEl: '.timeline-nav-down',
				prevEl: '.timeline-nav-up',
			},
		});
	}

	// Page load
	swiperAboutUsTimeline();

	/*------------------------------------*\
	    ABOUT US > AWARDS CAROUSEL
	\*------------------------------------*/

	function swiperAwardsCarousel() {
		var swiper = new Swiper('.awards-swiper', {
			slidesPerView: 1,
			spaceBetween: 30,
			loop: true,
			navigation: {
				nextEl: '.awards-button-next',
				prevEl: '.awards-button-prev',
			},
		});
	}

	// Page load
	swiperAwardsCarousel();

	/*------------------------------------*\
	    HOME PAGE > TESTIMONIALS
	\*------------------------------------*/

	function swiperTestimonials() {
		var swiper = new Swiper('.testimonials-container', {
			spaceBetween: 30,
			slidesPerView: 1,
			scrollbar: {
				el: '.testimonials-section .swiper-scrollbar',
				hide: false,
			},
			navigation: {
				nextEl: '.testimonials-section .swiper-button-next',
				prevEl: '.testimonials-section .swiper-button-prev',
			},
			breakpoints: {
				// When window width is >= 768px
				768: {
					slidesPerView: 2,
				},
				// When window width is >= 1024px
				1024: {
					slidesPerView: 3,
				},
			},
		});
	}

	// Page load
	swiperTestimonials();

	/*------------------------------------*\
	    OUR SERVICES > OTHER SERVICES
	\*------------------------------------*/

	function swiperOurServicesOtherServices() {
		// Exclude testimonials container from this generic selector
		var swiper = new Swiper('.other-services-container:not(.testimonials-container)', {
			spaceBetween: 30,
			scrollbar: {
				el: '.swiper-scrollbar',
				hide: false,
			},
			snapOnRelease: true,
			slidesPerView: 'auto',
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});
	}

	// Page load
	swiperOurServicesOtherServices();

	/*------------------------------------*\
	    REFRESH CAROUSELS ONCE STYLES LOAD
	\*------------------------------------*/

	// The main stylesheet loads asynchronously (media="print" swap), so the
	// carousels above can initialise before it applies and measure the wrong
	// sizes. Recalculate them once the stylesheet and images have loaded.
	function refreshCarousels() {
		$('.swiper-container-initialized').each(function() {
			if (this.swiper) {
				this.swiper.update();
			}
		});
		$('.logo-carousel.slick-initialized').slick('setPosition');
	}

	var mainStylesheet = document.querySelector('link[rel="stylesheet"][href*="style.min.css"]');
	if (mainStylesheet) {
		mainStylesheet.addEventListener('load', refreshCarousels);
	}

	if (document.readyState === 'complete') {
		refreshCarousels();
	} else {
		$(window).on('load', refreshCarousels);
	}

	/*------------------------------------*\
	    Global window resize events.
	\*------------------------------------*/

	// Swiper handles its own resizing; re-initialising here would stack
	// duplicate instances on the same element.
	var resizeTimer;
	$(window).on('resize', function(e) {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function() {
			// Single Service pages
			omitCurrentServiceFromList();
		}, 50);
	});
});
//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIiwic291cmNlcyI6WyJzY3JpcHRzLmpzIl0sImZpbGUiOiJzY3JpcHRzLmpzIn0=
